export default __webpack_public_path__ + "static/media/swimGoggles.c11fbee3.png";